<div class="rounded-2xl border border-surface-300 p-4">
    <div class="flex flex-row justify-between items-center text-lg font-bold">
        <div class="aeg-flex-row-g2 items-center ">
            <aeg-icon icon="pi pi-wallet" />
            Uw huidig {{serviceTitle}}-saldo
        </div>
        <div>{{ formatCurrency(availableAmount) }}</div>
    </div>
</div>
